
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/tAfoWaveDetailLine/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tAfoWaveDetailLine/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tAfoWaveDetailLine/findPage',
        method: 'post',
      data
    })
}

// 查询分页数据
export const findByWaveDetailId = (data) => {
  return axios({
    url: '/tAfoWaveDetailLine/findByWaveDetailId',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/http/moudules/tAfoWaveDetailLine.js